import { calculateTimeElapsedSinceLastTransitionOrMarkTime } from '../performanceTimeDifference';
import { mark } from '../performance';

const withAdRequestStartedEvent =
  ({ bidResult }) =>
  (adSpot, performance) => {
    const { guid: groupId } = adSpot;

    const adRequestStartedMark = `${groupId}_request_start`;
    mark(adRequestStartedMark, performance);

    const adRequestStartedTime =
      calculateTimeElapsedSinceLastTransitionOrMarkTime(
        adRequestStartedMark,
        performance,
      );

    if (!adRequestStartedTime) {
      return undefined;
    }

    return {
      schema:
        'iglu:au.com.realestate/media_ads_request_started/jsonschema/1-0-0',
      data: {
        event_name: 'media_ads_request_started',
        prebid_bidder: bidResult ? bidResult.hb_bidder : undefined,
        ad_request_start_time: adRequestStartedTime,
      },
    };
  };

export default withAdRequestStartedEvent;
